var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackspace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4229 2.25H5.17291C4.65541 2.25 4.25041 2.5125 3.98041 2.91L0.20041 8.5875C0.0354102 8.8425 0.0354102 9.165 0.20041 9.42L3.98041 15.09C4.25041 15.48 4.65541 15.75 5.17291 15.75H16.4229C17.2479 15.75 17.9229 15.075 17.9229 14.25V3.75C17.9229 2.925 17.2479 2.25 16.4229 2.25ZM13.6479 12.225C13.3554 12.5175 12.8829 12.5175 12.5904 12.225L10.4229 10.0575L8.25541 12.225C7.96291 12.5175 7.49041 12.5175 7.19791 12.225C6.90541 11.9325 6.90541 11.46 7.19791 11.1675L9.36541 9L7.19791 6.8325C6.90541 6.54 6.90541 6.0675 7.19791 5.775C7.49041 5.4825 7.96291 5.4825 8.25541 5.775L10.4229 7.9425L12.5904 5.775C12.8829 5.4825 13.3554 5.4825 13.6479 5.775C13.9404 6.0675 13.9404 6.54 13.6479 6.8325L11.4804 9L13.6479 11.1675C13.9329 11.4525 13.9329 11.9325 13.6479 12.225Z",
    fill: "#4A0DFB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackspace);
export default __webpack_public_path__ + "static/media/backspace.13b5b8d8404b5b1f9d5530e561d4d077.svg";
export { ForwardRef as ReactComponent };